export { dnsaddrResolver } from './dnsaddr.js';
//# sourceMappingURL=index.js.map